//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uid, date } from "quasar";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import { mapActions } from "vuex";
import { APP_DATETIME_SLASH, APP_DATE_SLASH } from "@/assets/js/appConfig";

export default {
    name: "DataAuditModal",
    components: {
        EntityTable: () => import("./EntityTable.vue"),
        AQModal
    },
    props: {
        entityDetails: {
            type: Object,
            default: () => ({ name: "", code: "" })
        }
    },
    data() {
        return {
            columns: [],
            tableData: [],
            showModal: true,
            loadingDummyColumns: true,
            errorRetrievingData: false,
            resetCurrentPage: false,
            loadingData: false,
            rowIdsSet: new Set(),
            iid: Symbol("local id"),
            tablePagination: {
                rowsPerPage: 10,
                page: 1,
                total: 0,
                from: 0,
                to: 10
            },
            dateTimeColumns: [],
            boolColumns: []
        };
    },
    created() {
        this.setColumns();
    },
    methods: {
        ...mapActions("dataStore", [
            "getAuditTableHeader",
            "getAuditData"
        ]),
        actionsDlg($event) {
            if ($event === "refresh") {
                this.setColumns();
            } else if ($event === "close") {
                this.$emit("input", false);
            }
        },
        setColumns() {
            const columns = [];
            this.getAuditTableHeader(this.entityDetails.code)
                .then(({ data }) => {
                    let eventCol, idCol;
                    data.forEach(att => {
                        const column = {
                            id: uid(),
                            code: att.code,
                            type: att.type,
                            name: att.code,
                            label: att.name,
                            field: att.code,
                            align: "left",
                            required: true,
                            isPublished: att.isPublished,
                            personalInfo: att.personalInfo
                        };
                        if (column.code !== "#eventDate" && (column.type === "date" || column.type === "datetime" || column.type === "time")) {
                            this.dateTimeColumns.push({ type: column.type, code: column.code });
                        }
                        if (column.type === "BOOLEAN") {
                            this.boolColumns.push(column.code);
                        }

                        switch (column.code) {
                            case "#modifiedBy":
                                column.label = this.$t("globalDataModel.modifiedBy");
                                break;
                            case "#modifiedVia":
                                column.label = this.$t("globalDataModel.modifiedVia");
                                break;
                            case "#event":
                                column.label = this.$t("globalDataModel.event");
                                break;
                            case "#eventDate":
                                column.label = this.$t("globalDataModel.eventDate");
                                break;
                            case "#processInstanceId":
                                column.label = this.$t("globalDataModel.processInstanceId");
                                break;
                            case "#applicationId":
                                column.label = this.$t("globalDataModel.applicationId");
                                break;
                            case "#modifiedByUserId":
                                column.label = this.$t("globalDataModel.modifiedByUserId");
                                break;
                            default:
                                break;
                        }
                        if (column.code === "#id") {
                            idCol = column;
                        } else if (column.code === "#event") {
                            eventCol = column;
                        } else if (column.type !== "attachment") {
                            columns.push(column);
                        }
                    });
                    columns.unshift(idCol);
                    columns.unshift(eventCol);
                    this.columns = columns;
                    this.loadingDummyColumns = false;
                    this.errorRetrievingData = false;
                    this.getData();
                })
                .catch(() => {
                    this.loadingDummyColumns = false;
                });
        },
        getData() {
            this.loadingData = true;
            const payload = {
                entityCode: this.entityDetails.code,
                from: this.tablePagination.from,
                to: this.tablePagination.to
            };
            this.getAuditData(payload)
                .then(({ data: { rows: list = [], oldData = [], total = 0 } = {} } = {}) => {
                    this.loadingData = false;
                    this.tablePagination = {
                        ...this.tablePagination,
                        total,
                        page: Math.floor(this.tablePagination.to / this.tablePagination.rowsPerPage)
                    };
                    this.rowIdsSet = new Set();
                    this.tableData = list.map((element, index) => {
                        this.dateTimeColumns.forEach(item => {
                            if (oldData[index][item.code] !== undefined && oldData[index][item.code] !== null) {
                                oldData[index][item.code] = this.formatDateTime(oldData[index][item.code], item.type);
                            }
                        });
                        this.boolColumns.forEach(item => {
                            if (oldData[index][item] !== undefined && oldData[index][item] !== null) {
                                oldData[index][item] = this.$t(`catalogs.${oldData[index][item]}`);
                            }
                        });

                        this.rowIdsSet.add(element.id);
                        delete oldData[index]["#id"];
                        delete oldData[index]["#event"];
                        const row = { ...element, [this.iid]: uid(), "#oldData": oldData[index] };
                        return row;
                    });
                })
                .catch(() => {
                    this.loadingData = false;
                    this.tableData = [];
                });
        },
        changePagination(data) {
            if (data === "cancel") {
                const { page } = this.tablePagination;
                this.tablePagination.page = 0;
                setTimeout(() => {
                    this.tablePagination.page = page;
                }, 0);
                return;
            }
            const { rowsPerPage = 10, page = 1 } = data || {};
            this.tablePagination = {
                ...this.tablePagination,
                page,
                rowsPerPage,
                from: rowsPerPage * (page - 1),
                to: rowsPerPage * page
            };
            this.getData();
        },
        formatDateTime(val, type) {
            switch (type) {
                case "date":
                    return date.formatDate(new Date(val), APP_DATE_SLASH);

                case "datetime":
                    return date.formatDate(new Date(val), APP_DATETIME_SLASH);

                case "time": {
                    const split = val.split(":");
                    return `${split[0]}:${split[1]}`;
                }

                default:
                    return "";
            }
        }
    }
};
